import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import emailjs from '@emailjs/browser';
import '../Styles/ContactSection.css';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(`Changing ${name} to: ${value}`);
    setFormData(prevData => {
      const newData = {
        ...prevData,
        [name]: value
      };
      console.log('New form data:', newData);
      return newData;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    console.log(formData);
    try {
      const result = await emailjs.send(
        'service_acwfkfm', 
        'template_q6r7052',
        formData,
        { publicKey: 'IppBeMdkXs9ssFoWm' }
      );

      console.log(result.text);
      alert('Message sent successfully!');
      setFormData({ name: '', email: '', message: '' });
    } catch (error) {
      console.error('Error:', error);
      alert('Failed to send message. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
};

  

  return (
    <section id="contact" className="contact-section">
      <Container>
        <motion.h2 
          className="section-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          Get In Touch
        </motion.h2>
        <Row className="justify-content-center">
          <Col md={6}>
            <motion.div 
              className="contact-form-container"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                    <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Your Name"
                    required
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Your Email"
                    required
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Control
                    as="textarea"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={4}
                    placeholder="Your Message"
                    required
                    />
                </Form.Group>
                <Button 
                    variant="primary" 
                    type="submit" 
                    className="submit-btn" 
                    disabled={isSubmitting}
                    >
                    {isSubmitting ? 'Sending...' : 'Send Message'}
                </Button>
              </Form>
            </motion.div>
          </Col>
          <Col md={6}>
            <motion.div 
              className="contact-info"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <h3>Let's Connect</h3>
              <p>I'm always open to new opportunities and collaborations. Feel free to reach out!</p>
              <div className="social-links">
                <a href="https://github.com/manojdeep14" target="_blank" rel="noopener noreferrer">
                  <FaGithub />
                </a>
                <a href="https://www.linkedin.com/in/manojdeep-dakavaram-12065117a/" target="_blank" rel="noopener noreferrer">
                  <FaLinkedin />
                </a>
                <a href="mailto:manojdeep14d@gmail.com">
                  <FaEnvelope />
                </a>
              </div>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ContactSection;